/* eslint-disable no-undef, id-match, no-console, react-hooks/exhaustive-deps, no-shadow, sonarjs/cognitive-complexity */
/* google */
import jwt_decode from 'jwt-decode';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Cookies from 'react-cookies';
import { useDispatch } from 'react-redux';
import { COOKIES_CONFIG, SOCIAL_CONFIG } from '../../brands/default/config';
import { COOKIES } from '../../brands/default/constants';
import {
  GOOGLE_ONE_TAP,
  PREFORMATTED_STRING,
} from '../../brands/default/content/components/media-buttons';
import { GLOBAL_LINKS } from '../../brands/default/links';
import { trackEvent } from '../../helpers/analytics';
import commonCookiesOptions from '../../helpers/commonCookiesOptions';
import { removeCookie, setCookie } from '../../helpers/cookieSetter';
import {
  loginGoogleUser,
  registerGoogleUser,
  showErrorToast,
} from '../../helpers/googleServiceAPI';
import {
  onGoogleLoginSuccess,
  subscribeGoogleUser,
} from '../../helpers/googleServiceInternal';
import { isLightBoxAllowed } from '../../helpers/lightbox';
import { setLoadingState } from '../../redux/actions/loading';
import { setLightbox } from '../../redux/actions/user';
import { LOADING_STATUS } from '../../redux/reducers/loading';
import useToast from '../_generic/toast/UseToast';

const isIframeVisible = (iframe) => {
  let isVisible = false;
  const iframeRect = iframe.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  if (
    ((iframeRect.top >= 0 && iframeRect.top <= windowHeight) ||
      (iframeRect.bottom <= windowHeight && iframeRect.bottom >= 0)) &&
    ((iframeRect.left >= 0 && iframeRect.left <= windowWidth) ||
      (iframeRect.right <= windowWidth && iframeRect.right >= 0))
  ) {
    isVisible = true;
  }

  return isVisible;
};

const GoogleOneTap = ({ registration = false, setUserEmail, setIsNewUser }) => {
  const dispatch = useDispatch();
  const toast = useToast();
  const router = useRouter();
  const CLIENT_ID =
    SOCIAL_CONFIG.GOOGLE.GOOGLE_ID[
      process.env.NEXT_PUBLIC_ENVIRONMENT || 'dev'
    ];
  const wowcherOrVoucher =
    PREFORMATTED_STRING.brandTerminology.Wowcher_or_voucher;
  const [showText, setShowText] = useState(false);
  const [bottomMargin, setBottomMargin] = useState('180px');
  const [topMargin, setTopMargin] = useState('220px');
  let mobileHeight;
  const showConfirmation = Cookies.load(COOKIES.showConfirmation);

  const registerOneTapUser = async ({ authTwo, dispatch, toast, token }) => {
    try {
      const response = await registerGoogleUser(token);

      if (response.data) {
        subscribeGoogleUser(email, registration, response.data.isNewEmail);
        setIsNewUser(true);
        onGoogleLoginSuccess(authTwo, dispatch);
      } else {
        dispatch(setLoadingState(LOADING_STATUS.READY));
        showErrorToast(
          response.message || GOOGLE_ONE_TAP.anErrorOccured,
          toast,
        );
      }
    } catch (error) {
      dispatch(setLoadingState(LOADING_STATUS.READY));
      showErrorToast(error.message || GOOGLE_ONE_TAP.anErrorOccured, toast);
    }
  };
  const loginOneTapUser = async ({
    authTwo,
    dispatch,
    email,
    registration,
    toast,
    token,
  }) => {
    const { COOKIE_SUBSCRIBED_EXPIRES } = COOKIES_CONFIG;
    if (Cookies.load(COOKIES.userInfo)) {
      Cookies.remove(COOKIES.userInfo, {
        domain: `.${process.env.NEXT_PUBLIC_DOMAIN_NAME}`,
        path: '/',
      });
    }
    dispatch(setLoadingState(LOADING_STATUS.LOADING));

    try {
      const response = await loginGoogleUser(token);
      const responseCode = response.response && response.response.code;

      if (responseCode === '2000') {
        Cookies.save(
          COOKIES.customerToken,
          response.response.data.customerToken,
          {
            ...commonCookiesOptions,
            COOKIE_SUBSCRIBED_EXPIRES,
          },
        );

        subscribeGoogleUser(email, registration);
        onGoogleLoginSuccess(authTwo, dispatch);
      } else if (responseCode === '2002') {
        registerOneTapUser({
          authTwo,
          dispatch,
          email,
          registration,
          toast,
          token,
        });
      } else if (responseCode === '2001') {
        dispatch(setLoadingState(LOADING_STATUS.READY));
        showErrorToast(
          response.response.message || GOOGLE_ONE_TAP.invalidGoogleTokenId,
          toast,
        );
      } else {
        dispatch(setLoadingState(LOADING_STATUS.READY));
        showErrorToast(GOOGLE_ONE_TAP.anErrorOccured, toast);
      }
    } catch (error) {
      dispatch(setLoadingState(LOADING_STATUS.READY));
      showErrorToast(error.message || GOOGLE_ONE_TAP.anErrorOccured, toast);
    }
  };
  const handleSuccess = (response) => {
    const token = response?.credential;
    const decodedToken = jwt_decode(response.credential);
    const email = decodedToken?.email;
    setUserEmail(email);

    loginOneTapUser({ dispatch, email, registration, toast, token });
    // Add tracking
    trackEvent('google_one_tap_sign_in');

    setCookie({
      expire: 365,
      key: COOKIES.userEmail,
      value: email,
    });
  };

  const callDigiohLightbox = () => {
    const [, queryString] = router.asPath.split(/\?|#/g);
    // Dont show Lightbox on organic guides page
    if (!queryString) {
      const isGuideURL = /\/guides/i;
      if (isGuideURL.test(document.location.href)) {
        return;
      }
    }
    const searchParameters = new URLSearchParams(queryString?.toLowerCase());
    const itoValue = searchParameters.get('ito');

    // Additional code for suppressing Digioh added from DTM's code

    const urlToExclude =
      /\/ppc|\/checkout|\/faqs|\/merchantfaqs|\/wowcher-dream-job\/wowcher-affiliates|marketplace.wowcher.co.uk|\/welcome|refer-a-friend|\/internetsafety/i;
    const lbSupressedChannels =
      /tth_salesgen|wowcher_affiliate|criteo|awin|wowcher_cloudiq|salescycle|wowcher_social_dyn-ret-new|wowcher_social_%20dyn-ret-new|tth-dyn-ret|catalogue_2020|wowcher_retarget/i;
    const lbReactRegex =
      /_react_r|_react_a|_react2_r|_react2_a|_urlstart.*urlend/i;
    const dodSessionSourceValue = Cookies.load(COOKIES.sessionSource)?.replace(
      lbReactRegex,
      '',
    );

    const lbFromEmail =
      (dodSessionSourceValue?.includes('wowcher_email') ||
        window.location.href.includes('/email-deals') ||
        document.location.search.includes('wowcher_email_') ||
        document.location.search.includes('livingsocial_email_')) &&
      !dodSessionSourceValue?.includes('dealzippy_new');

    let channelOK = true;

    if (dodSessionSourceValue?.length > 0) {
      if (lbSupressedChannels.test(dodSessionSourceValue)) {
        channelOK = false;
      } else {
        channelOK = true;
      }
    }

    if (
      channelOK &&
      !urlToExclude.test(document.location.href) &&
      (!lbFromEmail ||
        itoValue?.toLowerCase().includes('wowcher_email_mg_wpbls_')) &&
      itoValue !== 'wowcher_affiliate_' &&
      itoValue !== 'wowcher_email_' &&
      itoValue !== 'wowcher_retarget_display_rtbhouse' &&
      itoValue !== 'wowcher_retarget_display_criteo' &&
      itoValue !== 'wowcher_wpush' &&
      itoValue !== 'wowcher_native_taboola' &&
      itoValue !== 'tth-dyn-ret-'
    ) {
      console.log('called Digioh lightbox 2');
      // Call digioh lightbox barring the above conditions
      window?.DIGIOH_API?.showLB(window.DIGIOH_API.lb_type);
    }
  };

  const callLivingSocialLightbox = () => {
    const [, queryString] = router.asPath.split(/\?|#/g);
    const searchParameters = new URLSearchParams(queryString?.toLowerCase());
    const itoValue = searchParameters.get('ito');

    // Additional code for suppressing lightbox added from DTM's code
    const lbFromEmail =
      document.location.pathname.includes('/email-deals') ||
      document.location.search.includes('livingsocial_email_');
    const urlToExclude =
      /\/ppc|\/checkout|\/cashback|\/affiliates-livingsocial|\/faqs|\/merchantfaqs|\/welcome|marketplace.wowcher.co.uk|\/internetsafety/i;
    const lbSupressedChannels =
      /social_dyn_ret|livingsocialuk_affiliates|livingsocialie_affiliates|retarget_display|criteo_all-user_browse-abandon|awin|livingsocial_cloudiq|salescycle|email|wpush/i;
    const lbReactRegex = /_react_r|_react_a|_react2_r|_react2_a/i;
    const lbFromChannelValue = Cookies.load(COOKIES.sessionSource)?.replace(
      lbReactRegex,
      '',
    );
    let channelOK = true;

    if (lbFromChannelValue?.length > 0) {
      if (lbSupressedChannels.test(lbFromChannelValue)) {
        channelOK = false;
      } else {
        channelOK = true;
      }
    }

    // const preventLBShowAB = Cookies.load(COOKIES.lsIELightBox) === 'b';

    // if (
    //   process.env.NEXT_PUBLIC_SITE === SITE_LIVINGSOCIAL_IE &&
    //   preventLBShowAB
    // ) {
    //   channelOK = false;
    // }

    if (
      (channelOK ||
        itoValue?.toLowerCase().includes('wowcher_email_mg_wpbls_')) &&
      !urlToExclude.test(document.location.href) &&
      (!lbFromEmail ||
        itoValue?.toLowerCase().includes('wowcher_email_mg_wpbls_')) &&
      !itoValue?.match(/^livingsocial_email.+$/) &&
      !itoValue?.match(/^ls.+_email.+$/) &&
      !itoValue?.match(/^livingsocial.+_affiliates.+$/) &&
      !itoValue?.match(/^livingsocial.+_wpush.+$/) &&
      !itoValue?.match(/^livingsocial.+_retarget_display.+$/)
    ) {
      console.log('called LS lightbox');
      dispatch(setLightbox(true));
    }
  };
  const onOneTapSignedIn = (response) => {
    setShowText(false);
    handleSuccess(response);
  };
  const initializeGIS = () => {
    google.accounts.oauth2.initTokenClient({
      callback: onOneTapSignedIn,
      cancel_on_tap_outside: false,
      client_id: CLIENT_ID,
      prompt_parent_id: 'g_id_onload',
    });

    google.accounts.id.prompt((notification) => {
      if (notification.isNotDisplayed()) {
        console.log(notification.getNotDisplayedReason());
        // Call digioh lightbox for wowcher
        setShowText(false);
        removeCookie(COOKIES.googleOneTap);
        if (isLightBoxAllowed()) {
          setTimeout(() => {
            callDigiohLightbox();
          }, 4_000);
        }
        // dispatch this for LS
        if (wowcherOrVoucher !== 'Wowcher' && isLightBoxAllowed()) {
          callLivingSocialLightbox();
        }
      } else if (notification.isSkippedMoment()) {
        console.log(notification.getSkippedReason());
        setShowText(false);
        // add track event for when the user cancels
        trackEvent('google_one_tap_close');
        // Call digioh lightbox for wowcher
        removeCookie(COOKIES.googleOneTap);
        if (isLightBoxAllowed()) {
          callDigiohLightbox();
        }

        // dispatch this for LS
        if (wowcherOrVoucher !== 'Wowcher' && isLightBoxAllowed()) {
          callLivingSocialLightbox();
        }
      } else if (notification.isDismissedMoment()) {
        console.log(notification.getDismissedReason());
        // if the flow is restarted do not hide the sticky text
        if (notification.getDismissedReason() !== 'flow_restarted') {
          setShowText(false);
        }
        // dispatch this for LS
        if (
          wowcherOrVoucher !== 'Wowcher' &&
          notification.getDismissedReason() === 'cancel_called' &&
          isLightBoxAllowed()
        ) {
          callLivingSocialLightbox();
        }
      } else if (notification.isDisplayed()) {
        // fire the tracking call here
        console.log('google one tap displayed');
        trackEvent('google_one_tap_displayed');
        setTimeout(() => {
          const iframe = document.querySelector('#credential_picker_iframe');
          const iframeDesktop = document.querySelector(
            '#credential_picker_container',
          );
          const iframeDesktopHeight = iframeDesktop?.style?.height;
          const displayIframeDesktop = iframeDesktop?.style?.display;
          const iframeHeight = iframe?.style?.height;
          const displayIframe = iframe?.style?.display;
          if (iframeHeight) {
            mobileHeight = iframeHeight?.slice(
              0,
              Math.max(0, iframeHeight.length - 2),
            );
            setBottomMargin(mobileHeight);
          }
          if (iframeDesktopHeight) {
            const desktopHeight = iframeDesktopHeight?.slice(
              0,
              Math.max(0, iframeDesktopHeight.length - 2),
            );
            setTopMargin(desktopHeight);
          }
          if (
            (iframeHeight &&
              isIframeVisible(iframe) &&
              displayIframe !== 'none') ||
            (iframeDesktopHeight &&
              isIframeVisible(iframeDesktop) &&
              displayIframeDesktop !== 'none')
          ) {
            setShowText(true);
          }
        }, 2_000);
      }
    });
  };
  useEffect(() => {
    const element = document.createElement('script');
    element.setAttribute('src', 'https://accounts.google.com/gsi/client');
    element.async = true;
    element.defer = true;
    element.onload = () => initializeGIS();
    document.querySelector('body').appendChild(element);

    const timer = setTimeout(() => {
      console.log('Timer triggered');
      google.accounts.id.cancel();
      setShowText(false);
      // Call digioh lightbox for wowcher
      removeCookie(COOKIES.googleOneTap);
      if (isLightBoxAllowed()) {
        callDigiohLightbox();
      }
    }, 20_000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const DEFAULT_LINK =
    GLOBAL_LINKS[process.env.NEXT_PUBLIC_ENVIRONMENT || 'prod'];

  return (
    <>
      {showText && showConfirmation === 'b' && (
        <>
          <div className="sticky-text-content">
            <div>
              {
                'Submit your email address to subscribe to receive daily emails featuring local service, shopping and travel offers from Wowcher. You can change your email preferences or unsubscribe at any time by visiting our email preference centre or by clicking on the unsubscribe option, both of which are links in each of our emails. View our Privacy & Cookie Policy '
              }
              <a
                href={`${DEFAULT_LINK}/page/privacypolicy`}
                rel="noreferrer noopener"
                target="_blank"
              >
                {'HERE'}
              </a>
            </div>
          </div>
        </>
      )}
      <style global jsx>{`
        @media (min-width: 240px) {
          .sticky-text-content {
            font-size: 12px;
            position: fixed;
            z-index: 9999;
            text-align: center;
            border-radius: 8px;
            bottom: ${bottomMargin - 10}px;
            width: 100%;
            background-color: #fff;
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
            padding: 5px;
          }
        }
        @media (min-width: 769px) {
          .sticky-text-content {
            font-size: 12px;
            position: fixed;
            width: 375px;
            right: 29px;
            top: ${Number(topMargin) + 10}px;
            bottom: auto;
            z-index: 9999;
            text-align: center;
            border-radius: 8px;
          }
        }
      `}</style>
    </>
  );
};

GoogleOneTap.propTypes = {
  registration: PropTypes.bool,
  setIsNewUser: PropTypes.func,
  setUserEmail: PropTypes.func,
};

export default GoogleOneTap;
